module.exports = __webpack_public_path__ + "img/mclogi-mobile2@2x.91622d9.png";